import { Component, computed, input, output, signal } from '@angular/core';
import {
  RidAudioButton,
  RidBottomButton,
  RidCorrectAnswerModal,
  RidMechanicBackground,
  RidMechanicContent,
  RidMechanicTitle,
  RidMechanicWrapper,
  RidModalBackground,
  RidTopBar,
} from '../../components';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { delay, Waiter } from '@gametailors/web-core/misc';
import { IconBackspace } from '../../icons/i-backspace';
import { AudioEffectPlayer } from '../../utils/audio.utils';

@Component({
  selector: 'rid-number-writing',
  templateUrl: 'rid-number-writing.html',
  imports: [
    RidMechanicBackground,
    RidMechanicContent,
    RidMechanicTitle,
    RidMechanicWrapper,
    RidTopBar,
    RidAudioButton,
    NgClass,
    NgTemplateOutlet,
    RidBottomButton,
    RidCorrectAnswerModal,
    RidModalBackground,
    IconBackspace,
  ],
  host: {
    class: 'block',
  },
})
export class RidNumberWriting {
  numbers = input.required<number[]>();
  numberIndex = signal(0);
  number = computed(() => this.numbers()[this.numberIndex()].toString());
  state = signal<'QUESTION' | 'WRONG' | 'CORRECT'>('QUESTION');

  answer = signal('');
  attempt = signal(0);
  revelation = signal<string | undefined>(undefined);
  readonly revealWaiter = new Waiter();

  finished = output<void>();

  addNumber(num: number) {
    this.answer.update((c) => c + num.toString());
  }

  backspace() {
    this.answer.update((c) => c.slice(0, -1));
  }

  async checkAnswer() {
    if (this.number() === this.answer()) {
      AudioEffectPlayer.play('CORRECT');
      this.state.set('CORRECT');
      await delay(2500);
      this.goToNext();
      return;
    }

    AudioEffectPlayer.play('INCORRECT');
    this.state.set('WRONG');
    await delay(2500);

    if (this.attempt() === 0) {
      this.attempt.set(1);
      this.answer.set('');
      this.state.set('QUESTION');
      return;
    }

    await this.reveal();
    this.goToNext();
  }

  async reveal() {
    this.revelation.set(this.number());
    await this.revealWaiter.wait();
    this.revelation.set(undefined);
  }

  goToNext() {
    const isLastIndex = this.numberIndex() === this.numbers().length - 1;
    if (isLastIndex) {
      this.finished.emit();
      return;
    }

    this.answer.set('');
    this.attempt.set(0);
    this.numberIndex.update((c) => c + 1);
    this.state.set('QUESTION');
  }
}
